<button *ngIf="isEditMode" class="btn btn-primary" type="button" (click)="openAddQuestionBank(addQuestionBank);">Add Question Bank</button>

<ng-template #addQuestionBank let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Question Bank To Module</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addModuleQuestionBankFrom">
        <div class="modal-body">
            <error-message [errors]="errors"></error-message>

            <div class="row form-group">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="col-form-label">Question Banks</label>
                        <select name="title" class="form-select" formControlName="questionBankId">
                            <option *ngFor="let questionBank of questionBanks" [value]="questionBank.id">{{ questionBank.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="col-form-label">Audit Type</label>
                        <select name="title" class="form-select" formControlName="auditTypeId">
                            <option *ngFor="let auditType of auditTypes" [value]="auditType.id">{{ auditType.name}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="col-form-label">Order</label>
                        <input name="order" class="form-control" formControlName="zOrder" />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12 text-end">
                    <button type="button" class="btn btn-outline-primary modal-dismiss me-2" (click)="modal.close('Close');">Cancel</button>
                    <button type="button" class="btn btn-success modal-dismiss" (click)="addQuestionBankToModule();" [disabled]="submitAttempt">Ok</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
